import React, { createContext, useContext, useEffect } from 'react';

// O app é sempre claro (decisão do redesign). O provider continua existindo para não quebrar imports,
// e limpa a preferência antiga de tema escuro que possa ter ficado salva.
const ThemeContext = createContext({ isDarkMode: false, toggleDarkMode: () => {} });

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    try {
      localStorage.removeItem('theme');
    } catch {
      // storage indisponível: nada a limpar
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ isDarkMode: false, toggleDarkMode: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
